import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const EmailOutline: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="email-outline" size={size} color={color} />
);
